import React from 'react';
import ReactDOM from 'react-dom';
import serialize from 'form-serialize';
import PropTypes from 'prop-types';
import BootstrapForm from 'react-bootstrap/lib/Form';
import i18n from '../../../src/i18n/translate';
import FieldGroup from './FieldGroup';
import MultiRowFieldGroup from './MultiRowFieldGroup';

export default class MultiRowForm extends React.Component {
  static propTypes = {
    addButtonText: PropTypes.string,
    canSave: PropTypes.func,
    data: PropTypes.array,
    deleteButtonText: PropTypes.string,
    displaySaveButtonIcon: PropTypes.bool,
    scrollContainerId: PropTypes.string,
    saveAction: PropTypes.func,
    saveButtonText: PropTypes.string,
    savedButtonText: PropTypes.string
  };

  static defaultProps = {
    displaySaveButtonIcon: true,
    idField: 'id'
  };

  constructor(props) {
    super(props);

    this.state = {
      formState: [],
      dataValue: [...this.props.data]
    };
  }

  onValueChange = (obj) => {
    this.setState({ dataValue: obj });
  };

  onFormValueChange = (index) => {
    return obj => {
      this.setState({ dataValue: [
        ...this.state.dataValue.slice(0, index),
        Object.assign(this.state.dataValue[index], obj),
        ...this.state.dataValue.slice(index + 1)
      ] });
    };
  };

  save = (index) => {
    return async () => {
      let form = ReactDOM.findDOMNode(this.bootstrapForms[index]);
      let formState = this.state.formState;
      if (form.checkValidity()) {
        let obj = serialize(form, { hash: true, empty: true });
        Object.assign(this.state.dataValue[index], obj);
        formState[index] = { runValidation: false, isDisabled: true };
        this.setState({ formState: formState });
        await this.props.saveAction(this.state.dataValue[index], index);
        formState[index] = { runValidation: false, isDisabled: false, isSaved: true };
        this.setState({ formState: formState });
        return true;
      } else {
        let formState = this.state.formState;
        formState[index] = { errorMessage: i18n.t('Errors on the form!'), runValidation: true, isDisabled: false };
        this.setState({ formState: formState });
        return false;
      }
    }
  };

  canSaveRow(index) {
    if (typeof this.props.canSave === 'function') {
      if (!this.props.canSave(this.state.dataValue[index], index)) {
        return false;
      }
    }
    return true;
  }

  wrapWithForm = (element, data, index) => {
    let formState = this.state.formState[index] || {};
    return (<BootstrapForm ref={(form) => (this.bootstrapForms[index] = form)}>
      <FieldGroup onValueChange={this.onFormValueChange(index)}
        scrollContainerId={this.props.scrollContainerId}
        data={data}
        runValidation={formState.runValidation}>
        { element }
      </FieldGroup>
    </BootstrapForm>);
  };

  getSaveButtonIcon = formState => {
    const { displaySaveButtonIcon } = this.props;
    if (!displaySaveButtonIcon) return '';

    let saveButtonIcon = 'zmdi zmdi-check-circle';
    if (formState.isDisabled) {
      saveButtonIcon = 'zmdi zmdi-hc-spin zmdi-spinner';
    } else if (formState.isSaved) {
      saveButtonIcon = 'zmdi zmdi-check-circle text-success';
    }
    return saveButtonIcon;
  }

  getSaveButton = (index) => {
    let formState = this.state.formState[index] || {};
    let saveButtonText = this.props.saveButtonText || i18n.t('Save');
    let saveButtonClass = 'secondary';
    if (formState.isSaved) {
      saveButtonText = this.props.savedButtonText || i18n.t('Saved');
      saveButtonClass = 'link';
    }
    return {
      action: this.save(index),
      label: saveButtonText,
      className: saveButtonClass,
      icon: this.getSaveButtonIcon(formState),
      disabled: formState.isDisabled || !this.canSaveRow(index)
    };
  };

  render() {
    this.bootstrapForms = [];
    return <MultiRowFieldGroup
      addButton={{ label: this.props.addButtonText || i18n.t('Add') }}
      className="multi-row-field-group"
      dataValue={this.state.dataValue}
      onMultiValueChange={this.onValueChange}
      rowWrapper={this.wrapWithForm}
      rowClassName="col-8"
      rowButtonsClassName="col-4"
      rowButtons={[this.getSaveButton]}
      {...Object.assign({
        deleteButtonText: i18n.t('Delete'),
        saveButtonText: i18n.t('Save'),
        savedButtonText: i18n.t('Saved'),
        addButtonText: i18n.t('Add')
      }, this.props, { data: undefined })}
    />;
  }
}
